/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Video_Status_Nobody_LiveInputs */

const th_video_status_nobody_live = /** @type {(inputs: Video_Status_Nobody_LiveInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`ยังไม่มีใครถ่ายทอดสดเกมนี้`)
};

const en_video_status_nobody_live = /** @type {(inputs: Video_Status_Nobody_LiveInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Nobody is broadcasting this game yet.`)
};

const ja_video_status_nobody_live = /** @type {(inputs: Video_Status_Nobody_LiveInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`まだ誰もこの試合を配信していません。`)
};

const zh_video_status_nobody_live = /** @type {(inputs: Video_Status_Nobody_LiveInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`还没有人直播这场比赛。`)
};

const es_video_status_nobody_live = /** @type {(inputs: Video_Status_Nobody_LiveInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Todavía no hay nadie retransmitiendo este partido.`)
};

const pt_video_status_nobody_live = /** @type {(inputs: Video_Status_Nobody_LiveInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Ninguém está transmitindo este jogo ainda.`)
};

const id_video_status_nobody_live = /** @type {(inputs: Video_Status_Nobody_LiveInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Belum ada yang menyiarkan pertandingan ini.`)
};

const fr_video_status_nobody_live = /** @type {(inputs: Video_Status_Nobody_LiveInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Personne ne diffuse encore ce match.`)
};

const tl_video_status_nobody_live = /** @type {(inputs: Video_Status_Nobody_LiveInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Wala pang nagsasahimpapawid ng larong ito.`)
};

const vi_video_status_nobody_live = /** @type {(inputs: Video_Status_Nobody_LiveInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Chưa ai phát trận này.`)
};

const ko_video_status_nobody_live = /** @type {(inputs: Video_Status_Nobody_LiveInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`아직 이 경기를 중계하는 사람이 없습니다.`)
};

const de_video_status_nobody_live = /** @type {(inputs: Video_Status_Nobody_LiveInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Dieses Spiel überträgt noch niemand.`)
};

const ru_video_status_nobody_live = /** @type {(inputs: Video_Status_Nobody_LiveInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Этот матч пока никто не транслирует.`)
};

const tr_video_status_nobody_live = /** @type {(inputs: Video_Status_Nobody_LiveInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Bu maçı henüz kimse yayınlamıyor.`)
};

const it_video_status_nobody_live = /** @type {(inputs: Video_Status_Nobody_LiveInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Nessuno sta ancora trasmettendo questa partita.`)
};

const pl_video_status_nobody_live = /** @type {(inputs: Video_Status_Nobody_LiveInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Nikt jeszcze nie transmituje tego meczu.`)
};

const uk_video_status_nobody_live = /** @type {(inputs: Video_Status_Nobody_LiveInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Цей матч поки ніхто не транслює.`)
};

const hi_video_status_nobody_live = /** @type {(inputs: Video_Status_Nobody_LiveInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`इस मैच को अभी कोई प्रसारित नहीं कर रहा।`)
};

const ar_video_status_nobody_live = /** @type {(inputs: Video_Status_Nobody_LiveInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`لا أحد يبثّ هذه المباراة بعد.`)
};

const ms_video_status_nobody_live = /** @type {(inputs: Video_Status_Nobody_LiveInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Belum ada sesiapa menyiarkan perlawanan ini.`)
};

const bn_video_status_nobody_live = /** @type {(inputs: Video_Status_Nobody_LiveInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`এই খেলা এখনও কেউ সম্প্রচার করছেন না।`)
};

const zh_tw2_video_status_nobody_live = /** @type {(inputs: Video_Status_Nobody_LiveInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`還沒有人轉播這場比賽。`)
};

const zh_hk2_video_status_nobody_live = /** @type {(inputs: Video_Status_Nobody_LiveInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`還沒有人轉播這場比賽。`)
};

const ur_video_status_nobody_live = /** @type {(inputs: Video_Status_Nobody_LiveInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`یہ میچ ابھی کوئی نشر نہیں کر رہا۔`)
};

const fa_video_status_nobody_live = /** @type {(inputs: Video_Status_Nobody_LiveInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`هنوز کسی این بازی را پخش نمی‌کند.`)
};

const sw_video_status_nobody_live = /** @type {(inputs: Video_Status_Nobody_LiveInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Hakuna anayerusha mchezo huu bado.`)
};

const nl_video_status_nobody_live = /** @type {(inputs: Video_Status_Nobody_LiveInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Nog niemand zendt deze wedstrijd uit.`)
};

/**
* | output |
* | --- |
* | "Nobody is broadcasting this game yet." |
*
* @param {Video_Status_Nobody_LiveInputs} inputs
* @param {{ locale?: "th" | "en" | "ja" | "zh" | "es" | "pt" | "id" | "fr" | "tl" | "vi" | "ko" | "de" | "ru" | "tr" | "it" | "pl" | "uk" | "hi" | "ar" | "ms" | "bn" | "zh-TW" | "zh-HK" | "ur" | "fa" | "sw" | "nl" }} options
* @returns {LocalizedString}
*/
export const video_status_nobody_live = /** @type {((inputs?: Video_Status_Nobody_LiveInputs, options?: { locale?: "th" | "en" | "ja" | "zh" | "es" | "pt" | "id" | "fr" | "tl" | "vi" | "ko" | "de" | "ru" | "tr" | "it" | "pl" | "uk" | "hi" | "ar" | "ms" | "bn" | "zh-TW" | "zh-HK" | "ur" | "fa" | "sw" | "nl" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Video_Status_Nobody_LiveInputs, { locale?: "th" | "en" | "ja" | "zh" | "es" | "pt" | "id" | "fr" | "tl" | "vi" | "ko" | "de" | "ru" | "tr" | "it" | "pl" | "uk" | "hi" | "ar" | "ms" | "bn" | "zh-TW" | "zh-HK" | "ur" | "fa" | "sw" | "nl" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "th") return th_video_status_nobody_live(inputs)
	if (locale === "ja") return ja_video_status_nobody_live(inputs)
	if (locale === "zh") return zh_video_status_nobody_live(inputs)
	if (locale === "es") return es_video_status_nobody_live(inputs)
	if (locale === "pt") return pt_video_status_nobody_live(inputs)
	if (locale === "id") return id_video_status_nobody_live(inputs)
	if (locale === "fr") return fr_video_status_nobody_live(inputs)
	if (locale === "tl") return tl_video_status_nobody_live(inputs)
	if (locale === "vi") return vi_video_status_nobody_live(inputs)
	if (locale === "ko") return ko_video_status_nobody_live(inputs)
	if (locale === "de") return de_video_status_nobody_live(inputs)
	if (locale === "ru") return ru_video_status_nobody_live(inputs)
	if (locale === "tr") return tr_video_status_nobody_live(inputs)
	if (locale === "it") return it_video_status_nobody_live(inputs)
	if (locale === "pl") return pl_video_status_nobody_live(inputs)
	if (locale === "uk") return uk_video_status_nobody_live(inputs)
	if (locale === "hi") return hi_video_status_nobody_live(inputs)
	if (locale === "ar") return ar_video_status_nobody_live(inputs)
	if (locale === "ms") return ms_video_status_nobody_live(inputs)
	if (locale === "bn") return bn_video_status_nobody_live(inputs)
	if (locale === "zh-TW") return zh_tw2_video_status_nobody_live(inputs)
	if (locale === "zh-HK") return zh_hk2_video_status_nobody_live(inputs)
	if (locale === "ur") return ur_video_status_nobody_live(inputs)
	if (locale === "fa") return fa_video_status_nobody_live(inputs)
	if (locale === "sw") return sw_video_status_nobody_live(inputs)
	if (locale === "nl") return nl_video_status_nobody_live(inputs)
	return en_video_status_nobody_live(inputs)
});